import { Component, Input, OnChanges, SimpleChange, SimpleChanges, OnDestroy } from '@angular/core';
import { NetFacadeService } from 'netview';
import { MessageService } from 'base';
import { AgentDto } from 'UvExplorerServer.Dtos.TS/Agents';
import { DateService } from 'base';

@Component({
	selector: 'agent-client',
	templateUrl: './agent-client.component.html',
	styleUrls: ['./agent-client.component.scss']
})
export class AgentClientComponent implements OnChanges, OnDestroy {

	@Input()
	public agent: AgentDto;

	private destroyed: boolean;

	public isClientRegistered: boolean;
	public clientId: string;
	public clientMachine: string;
	public lastConfigPollTime: string;

	public displayUnregisterConfirm: boolean;

	constructor(private netFacadeService: NetFacadeService,
		private messageService: MessageService,
		private dateService: DateService) {

		this.agent = null;
		this.destroyed = false;
		this.displayUnregisterConfirm = false;

		this.setViewProperties();
	}

	public formatDateHm(date: string | Date): string {
		return this.dateService.formatDateHm(date);
	}

	private setViewProperties(): void {
		this.setIsClientRegistered();
		this.setClientId();
		this.setClientMachine();
		this.setLastConfigPollTime();
	}

	private setIsClientRegistered(): void {
		if (this.agent) {
			this.isClientRegistered = this.agent.HasClientAgentGuid;
		}
		else {
			this.isClientRegistered = false;
		}
	}

	private setClientId(): void {
		if (this.agent && this.agent.HasClientAgentGuid) {
			this.clientId = this.agent.ClientAgentGuid;
		}
		else {
			this.clientId = "";
		}
	}

	private setLastConfigPollTime(): void {
		if (this.agent && this.agent.HasClientAgentGuid && this.agent.HasClientAgentLastConfigPollTime) {
			this.lastConfigPollTime = this.agent.ClientAgentLastConfigPollTime;
		}
		else {
			this.lastConfigPollTime = "";
		}
	}

	private setClientMachine(): void {
		if (this.agent && this.agent.HasClientAgentGuid) {
			this.clientMachine = this.agent.ClientAgentMachine;
		}
		else {
			this.clientMachine = "";
		}
	}

	public ngOnChanges(changes: SimpleChanges): void {

		if (this.destroyed)
			return;

		if (changes["agent"]) {
			this.setViewProperties();
		}
	}

	public ngOnDestroy(): void {
		this.destroyed = true;
	}

	public unregister(): void {
		this.displayUnregisterConfirm = true;
	}

	public refresh(): void {
		if (this.agent) {
			this.netFacadeService.getAgentFromServer(this.agent.Guid).subscribe(
				(refreshAgent: AgentDto) => {
					this.agent.copyAgentProperties(refreshAgent);
					this.setViewProperties();
					this.messageService.displayInfoMessage("Client details have been updated");
				},
				(error) => {
					this.messageService.displayErrorMessage("Could not update client details");
				});
		}
	}

	public doUnregister(): void {

		this.displayUnregisterConfirm = false;

		if (this.agent) {
			this.netFacadeService.unbindAgent(this.agent).subscribe(
				(result: boolean) => {
					this.agent.clearAgentProperties();

					this.setViewProperties();

					this.messageService.displayInfoMessage("Client has been unregistered");
				},
				(error) => {
					this.messageService.displayErrorMessage("Could not unregister client");
				});
		}
	}

	public cancelUnregister(): void {
		this.displayUnregisterConfirm = false;
	}

}
